var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"sj-loading-theme2",attrs:{"src":require('../../../../../assets/image/loading_quiet.png')}})}
var staticRenderFns = []

export { render, staticRenderFns }